import React, { useState, useMemo } from "react";
import { useHistory, Link, Redirect } from "react-router-dom";
import { AuthNetworkLayer, persistAuthTokens, PolicyHelper } from "helpers";
import { useSelector, useDispatch } from "react-redux";
import { setLoading, setLoadingMessage } from "globals/overlays";
import Timer from "react-compound-timer";
import UpdatedModal from "components/misc/Modal-V2";
import jwtDecoder from "jwt-decode";
import CircleDesign from "./CircleDesign/index";
import SmsOTP from "./Assets/smsOTP";
import OtpInput from "./OtpInput";
import './verification.scss'
const { testIds } = require("testing/testIds");
import {
	getUser,
	login,
	getToken,
	setRenewablePolicies,
	getUserFormData,
	getUserId,
	setCurrentUser,
	setPolicies,
	setExtendablePolicies,
	getTransactionType,
	setCoverNotePolicies,
	setActivePolicies,
	setHasMotorPolicies,
	setHasHomePolicies,
	setHasLiabilitiesPolicies,
	setActivePolicy,
	setActiveRisk
} from "globals/auth";
import { clearStoreOnLogin } from "globals/misc";
import HoverZoomLayeredImage from "../OTP/HoverZoomLayeredImage";
import { PAY_BALANCE, RENEWAL } from "pages/RenewPolicy/constants";
import {
	getExtendablePoliciesPaymentPlan,
	enrichPoliciesWithPaymentPlan,
	getAuthErrorMessage,
	isPolicyManagerBrokerAccessMessage,
} from "helpers/auth";
import { ERROR } from "../Modal-V2/constants";
import { createLog } from "helpers/log";
import { clearPolicyManager } from "globals/policymanager";
import { getAllClaimStatus, getClaims } from "api/dNet/Claims";
import { setClaimsForTracking, setClaimsStatuses } from "globals/claims";
import logger from "utils/logger";
import { persistor } from "../../../globals";

const otpImage = "/assets/img/otp-image.svg";
const phone = "/assets/img/phone.svg";

function decodeAuthResponsePayload(payload) {
	if (!payload) return {};

	try {
		return jwtDecoder(payload);
	} catch (e) {
		logger.log("auth response decode error", e);
		return {};
	}
}

export default function OTPVerification({
	isClaims = false,
	isTrackAClaim = false,
	isPayBalance = false,
	isPolicyManager = false,
	location,
}) {
	const token = useSelector(getToken);
	const history = useHistory();
	const dispatch = useDispatch();
	const user = useSelector(getUser);
	const userId = useSelector(getUserId);
	const userFormData = useSelector(getUserFormData);
	const transactionType = useSelector(getTransactionType);
	const [error, setError] = useState("");
	const [OTPToken, setOTPToken] = useState("");
	const [isModalVisible, showModal] = useState(false);
	const search = location?.search || "";
	let method = location.state;
	const tokenParam = useMemo(() => {
		const params = new URLSearchParams(search);
		return params.get("t");
	}, [search]);
	const decodedTokenizedLink = useMemo(() => {
		if (!tokenParam) return null;
		try {
			return jwtDecoder(tokenParam);
		} catch (e) {
			logger.log("tokenized link decode error", e);
			return null;
		}
	}, [tokenParam]);

	/**
	 * Similar to the function that is used to generate
	 * the OTP in the previous page.*/
	const resendToken = async () => {
		try {
			dispatch(setLoadingMessage('Resending token'));
			dispatch(setLoading(true));
			
			// use the values passed from OTP
			let response = await AuthNetworkLayer.sendOTP(
				`${user.first_name || user.last_name || user.company_name}`,
				{ [method.method]: method.contact },
				userId,
				userFormData.national_id,

			);
			if (!response.success) throw new Error(response.message);
		} catch (e) {
			setError(e.message);
			showModal(true);
		} finally {
			dispatch(setLoading(false));
		}
	};

	const checkPoliciesForDepartmentClass = (policies, departmentClass) => {
		return policies.some(policy => policy.department_class === departmentClass);
	}
	let otp = "";
	const handleOtpComplete = (otp) => {
		setOTPToken(otp); // Update OTPToken when OTP input is completed
	  };
	const getClaimStatus =async () =>{
		try
		{
		const claimsStatuses = await getAllClaimStatus();
		dispatch(setClaimsStatuses(claimsStatuses.response))
		}
		catch(e)
		{
			logger.log(e);
		}

	} 




	const fetchClaims = async (policies) => {
		let i;
		const newClaimsArray = [];
		for (i = 0; i < policies?.length; i++) {
			dispatch(setLoadingMessage(`Loading policy details: ${policies?.length - (i+1)} policies remaining`));
			const payload = {
				policy_id: policies[i]?.policy_id,
			};


			const retrievedClaims = await getClaims(payload);

			if (!retrievedClaims?.success)
				continue;

			newClaimsArray.push(...retrievedClaims.claims);
		}
		return newClaimsArray;
	}
	
	/**
	 * Verifies an entered user token
	 * @param {*} otp
	 * @param {*} userid
	 * @param {*} national_id
	 
	 */
	const verifyToken = async (otp, userid, national_id) => {
		let response,
			data = {};
		let navigateToNext = null;
		let logErrorMessage = "";

		let hasMotorPolicies = false;
		let hasHomePolicies = false;
		let hasLiabilityPolicies = false;
		try {
			dispatch(setLoadingMessage('Authenticating User'));
			dispatch(setLoading(true));
			response = await AuthNetworkLayer.verifyOTP(otp, userid, national_id, transactionType);
			data = decodeAuthResponsePayload(response?.data || response?.result);
			if (!response?.success) {
				throw new Error(getAuthErrorMessage({ response, data }));
			}

			// Clear all state AFTER successful authentication but BEFORE setting new user data
			dispatch(clearStoreOnLogin());
			// Purge persisted storage to ensure no cached data remains
			await persistor.purge();

			let fetchedClaims = [];
			if (isTrackAClaim)
			{
				let statuses = await getClaimStatus();
				fetchedClaims = [...await fetchClaims(data?.policies)];
			}

			if (fetchedClaims?.length)
			dispatch(setClaimsForTracking(fetchedClaims));

			persistAuthTokens(data);
			dispatch(setCurrentUser(data.user));

			

			hasMotorPolicies = checkPoliciesForDepartmentClass(data?.policies, 'Motor');
			hasHomePolicies = checkPoliciesForDepartmentClass(data?.policies, 'Fire');
			hasLiabilityPolicies = checkPoliciesForDepartmentClass(data?.policies, 'Liability');

			dispatch(setHasMotorPolicies(hasMotorPolicies));
			dispatch(setHasHomePolicies(hasHomePolicies));
			dispatch(setHasLiabilitiesPolicies(hasLiabilityPolicies));

			const filteredPolicies = data.policies.filter(policy=> policy.department_class !== 'Liability');

			if (isClaims) {
				const filteredPoliciesForClaims = filteredPolicies.filter(policy=> policy.department_class !== 'Fire');
				dispatch(setPolicies(PolicyHelper.filterForClaims(filteredPoliciesForClaims)));
				navigateToNext = () => (isTrackAClaim ? history.push("/track-my-claim/claim-listing") : history.push("/claims/contact-info"));
			} else if (transactionType === PAY_BALANCE) {
				let extendablePolices = await getExtendablePoliciesPaymentPlan(filteredPolicies);
				dispatch(setExtendablePolicies(PolicyHelper.filterForExtension(extendablePolices)));
				navigateToNext = () => history.push(`/${PAY_BALANCE}/contact-info`);
			} else if (isPolicyManager) {
				// Preserve the full non-liability policy set for scoped selectors like Documents Center.
				dispatch(setPolicies(filteredPolicies));

				const filteredPoliciesForPolicyManager = filteredPolicies.filter(policy=> policy.department_class !== 'Fire');
				const activePoliciesForManager = PolicyHelper.findAllActiveAndRenewablePolicies(filteredPoliciesForPolicyManager);
				const enrichedActivePoliciesForManager = await enrichPoliciesWithPaymentPlan(activePoliciesForManager);
				dispatch(setActivePolicies(enrichedActivePoliciesForManager));

				// Only auto-select activePolicy if:
				// 1. There's a tokenized link with a specific policy_id, OR
				// 2. User has only ONE applicable policy
				// Otherwise, let user select on the policy listing page
				let selectedPolicy = null;
				if (decodedTokenizedLink?.policy_id) {
					// Tokenized link - find the specific policy
					const targetId = String(decodedTokenizedLink.policy_id);
					selectedPolicy = enrichedActivePoliciesForManager.find(p => String(p.policy_id) === targetId)
						|| activePoliciesForManager.find(p => String(p.policy_id) === targetId)
						|| filteredPoliciesForPolicyManager.find(p => String(p.policy_id) === targetId)
						|| data?.policies?.find(p => String(p.policy_id) === targetId);
				} else if (enrichedActivePoliciesForManager.length === 1) {
					// Only one policy - auto-select it
					selectedPolicy = enrichedActivePoliciesForManager[0];
				}

				if (selectedPolicy) {
					if (!selectedPolicy?.paymentPlan) {
						const [enrichedSelectedPolicy] = await enrichPoliciesWithPaymentPlan([selectedPolicy]);
						selectedPolicy = enrichedSelectedPolicy || selectedPolicy;
					}
					dispatch(setActivePolicy(selectedPolicy));
					const risks = Array.isArray(selectedPolicy?.risks) ? selectedPolicy.risks : [];
					let selectedRisk = null;
					if (decodedTokenizedLink?.risk_id) {
						const targetRiskId = String(decodedTokenizedLink.risk_id);
						selectedRisk = risks.find(risk => String(risk?.risk_id) === targetRiskId) || null;
					}
					if (!selectedRisk && risks.length) selectedRisk = risks[0];
					if (selectedRisk) dispatch(setActiveRisk(selectedRisk));
				}

				dispatch(clearPolicyManager());
				const nextRoute = tokenParam ? `/manage-your-policy/upload-supporting-documents${search}` : "/manage-your-policy/policy-editor";
				navigateToNext = () => (tokenParam ? history.push(nextRoute, { from: 'otp' }) : history.push(nextRoute));
			} else {
				dispatch(setRenewablePolicies(PolicyHelper.filterForRenewal(filteredPolicies)));
				navigateToNext = () => history.push(`/${RENEWAL}/contact-info`);
			}
			dispatch(login());
			navigateToNext?.();
		} catch (e) {
			logErrorMessage = e?.message || "An error occurred while verifying OTP";
			setError(logErrorMessage);
			showModal(true);
		} finally {
			dispatch(setLoading(false));
			const responseErrorMessage = response?.success === false
				? (response?.message || data?.message || "")
				: "";
			createLog({
				trn: national_id,
				type: `${transactionType}-OTP`,
				data: { ...data },
				errors: { message: logErrorMessage || responseErrorMessage },
			}).catch(() => {});
		}
		if (token === "") return <Redirect to="/renewal/login" />;
	};
 
	return (
		<section className="otp-style otp-page-wrapper" style={{width: "100%"}} data-testid={testIds.auth.otpVerification.page.container}>
			<UpdatedModal
				modalType={ERROR}
				title={isPolicyManagerBrokerAccessMessage(error) ? "Access Not Authorized" : "An Error Occurred"}
				showModal={isModalVisible}
				primaryLabel="OK"
				primaryCallback={() => showModal(false)}
				closeModal={() => {
					showModal(false);
					setError("");
				}}
			>
				<div>{error}</div>
			</UpdatedModal>
			<div className="otp-container">
				<div className="otp-split-layout">
					<div className="left-panel">
						<div>
							<HoverZoomLayeredImage
							background="/assets/img/login/otp/verification/background.svg"
							foreground="/assets/img/login/otp/verification/foreground.svg"
							zoomScale={1.1}
							zoomZ={80}
							/>
			
							<div className="brand-message">
								<h2>Secure your account</h2>
								<p>
									Two factor authentification adds An extra layer of security to your account
								</p>
							</div>
						</div>
						
					</div>
					<div className="right-panel">
						<Timer initialTime={300000} direction="backward" timeToUpdate={950}>
							{({ reset, start }) => (
								<div className="view otp-verification">
									<div className="otp-phone">
										<svg width="33" height="55" viewBox="0 0 33 55" fill="none" xmlns="http://www.w3.org/2000/svg">
											<mask id="mask0_10123_124" maskUnits="userSpaceOnUse" x="0" y="0" width="33" height="55">
											<path d="M32.712 0H0V54.517H32.712V0Z" fill="white"/>
											</mask>
											<g mask="url(#mask0_10123_124)">
											<path d="M26.974 0C28.4466 0.253113 29.7987 0.973004 30.8309 2.05339C31.863 3.13378 32.5204 4.51741 32.706 6L32.711 48.261C32.5536 49.7925 31.8848 51.2263 30.8126 52.331C29.7403 53.4357 28.3271 54.147 26.801 54.35C20.084 54.019 12.87 54.835 6.21 54.368C4.61174 54.2229 3.11498 53.5219 1.98029 52.387C0.845592 51.2522 0.144831 49.7553 0 48.157L0.018 5.906C0.227449 4.4444 0.893322 3.08634 1.92055 2.0257C2.94778 0.965072 4.28385 0.256097 5.738 0L26.974 0ZM29.522 9.131H3.19V40.454H29.523L29.522 9.131ZM15.906 43.88C12.135 44.396 12.692 50.461 16.931 49.896C20.591 49.408 20.073 43.31 15.906 43.88Z" fill="#00A9E0"/>
											</g>
										</svg>

									</div>
									<div className="otp-verify-header-container">
										<div className="otp-verify-header-title">Verification Code</div>
										<div className="otp-verify-header-desc">We sent a code to { method.contact } Please enter the code to verify its you.</div>
									</div>
									<Link
										style={{ marginTop: "1em", justifySelf: "flex-start", fontSize: "14px", textDecoration: "none", textUnderlineOffset: 5, color: "#00A9E0", margin: "20px 0" }}
										data-testid={testIds.auth.otpVerification.actions.changeMethodLink}
										to={
											isTrackAClaim
												? "/track-my-claim/otp"
												: isClaims
													? "/claims/otp"
												: isPolicyManager
													? (tokenParam ? `/manage-your-policy/otp${search}` : "/manage-your-policy/otp")
														: (transactionType === PAY_BALANCE)
															? "/paybalance/otp"
															: "/renewal/otp"
										}
									>
										Change verification method?
									</Link>
									<p style={{width: "100%", display: "none",textAlign: "center", fontSize :"14px", fontWeight: 400}}>Please enter your One Time Password (OTP) to verify your identity</p>
									<div className="field"
									style={{
										display: "flex",
										flexDirection: "column"
									}}
									data-testid={testIds.auth.otpVerification.form.container}
									>
										<OtpInput length={6} onComplete={handleOtpComplete} codeInputTestId={testIds.auth.otpVerification.form.codeInput} />
										{/* <input type="text" value={OTPToken} onChange={e => setOTPToken(e.target.value)} maxLength={6} /> */}
										<span style={{display: "flex", fontSize: "12px", margin: "25px 0", justifyContent: "center", alignItems: "center"}}>
											<span style={{fontWeight: 600, paddingRight: "10px", color: "#707070"}}>Code expires in: </span>
											<span className="otp-code-timer" data-testid={testIds.auth.otpVerification.state.timer}>
												<b style={{color: "red"}}>
												<Timer.Minutes />:
												<Timer.Seconds formatValue={value => (value < 10 ? `0${value}` : `${value}`)} />
												</b>
											</span>
										</span>
									</div>

									

									<div className="button-wrapper-otp">
										
										<button
											className="button-v2 primary-theme-btn otp-verify-button"
											data-testid={testIds.auth.otpVerification.actions.verifyButton}
											onClick={() => verifyToken(OTPToken, userId, userFormData.national_id)}
											disabled={OTPToken.length === 0}
										>
											<span>Verify Identity</span>  
										</button>
										<div className="otp-resend">
											<span className="otp-resend-desc">Didn’t Receive the code?</span>
											<span
												onClick={() =>
													resendToken().then(() => {
														reset();
														start();
													})
												}
												className="button secondary-otp "
												data-testid={testIds.auth.otpVerification.actions.resendButton}
											>
												Resend code
											</span>
										</div>
									</div>
								</div>
							)}
						</Timer>
					</div>
				</div>
			</div>
		</section>
	);
}
